<div [formGroup]="parentForm" id="radio-control-container">
    <mm-control-label [controlName]="controlName" [label]="title" [hasError]="hasError"
        id="delivery-method-control-label">
    </mm-control-label>
    <div class="radio-container">
        <input type="radio" formControlName="{{controlName}}" value="firstParty" id="{{controlName + '-firstParty'}}"
            attr.data-testid="{{controlName + '-firstParty-input'}}">
        <label for="{{controlName + '-firstParty'}}">
            <div attr.data-testid="{{controlName + '-firstParty-label'}}" class="radio-label">First party (account
                holder)</div>
        </label>
    </div>
    <div class="radio-container">
        <input type="radio" formControlName="{{controlName}}" value="thirdParty" id="{{controlName + '-thirdParty'}}"
            attr.data-testid="{{controlName + '-thirdParty-input'}}">
        <label for="{{controlName + '-thirdParty'}}">
            <div attr.data-testid="{{controlName + '-thirdParty-label'}}" class="radio-label">Third party</div>
        </label>
        <sdps-tooltip #tooltip sdps-id="top-tooltip" topic-id="top-tooltip-topic" position="right"
            data-testid="thirdPartyTooltip" id="checkTransactionDetails_thirdPartyTooltip">
            <span slot="tooltip-content">
                <div class="small-bottom-spacer"><strong>Additional Information:</strong></div>
                <div class="small-bottom-spacer">Use Third Party check box for payees other than the account
                    holder, or when the payee account
                    registration is not “Like Registered” and thus the check represents a change in
                    ownership.</div>
            </span>
            <span slot="trigger-element">
                <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
            </span>
        </sdps-tooltip>
    </div>
    <span *ngIf="hasError" class="error-text">{{errorText}}</span>
</div>
